/*    
<summary>
   This file is used to provide initial values or state to the User Data observables.
   Developer:Pratiksha Sharma, Created Date:06-August-2025
</summary>
*/

import { IAddStoreCms } from "../../models/forms/IAddStoreCms";


export const initialState: IAddStoreCms = {
    Id: 0,
    StoreName: "",
    Email: "",
    MobileNumber: "",
    Address: "",
    StoreDetails: "",
    StoreMapURL: "",
    StoreCode: "",
    AccessInformation: "",
    StorePhoneMessage: "",
    PhoneMessageVisible: true
}